import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';

import CN from './Card.module.scss';

export const Card = ({ children, className }) => {
  const { isDarkMode } = useTheme();

  return (
    <div data-bem="Card" className={cn({ [CN.component]: true, [CN.dark]: isDarkMode, [className]: className })}>
      {children}
    </div>
  );
};

export const CardHeader = ({ children }) => (
  <div data-bem="CardHeader" className={CN.header}>
    {children}
  </div>
);

export const CardBody = ({ children }) => (
  <div data-bem="CardBody" className={CN.body}>
    {children}
  </div>
);

export const CardFooter = ({ children }) => (
  <div data-bem="CardFooter" className={CN.footer}>
    {children}
  </div>
);
